export default __webpack_public_path__ + "static/TQD_logo-1c9050146b609a8da4cbd46a606054f3.png";